import '../../assets/styles/inbox/main.scss';
import vi from '../../assets/images/svg/next-flag-VN.svg';
import dropdown from '../../assets/images/svg/dropdown.svg';
import { connect } from 'react-redux';
import Logo from './components/Global/logo';
import AvatarUser from './components/Images/AvatarUser';
import { Popover } from 'react-tiny-popover';
import { useState } from 'react';
import { logoutUser } from '../../store/action/userAction';

const MainChannel = (props) => {
   const { children, user, logoutUser } = props;
   const [isOpen, setIsOpen] = useState(false);
   return (
      <div className="main-wrapper main-style">
         <div className="app-header-account--container">
            <Logo />
            <div className="header-actions app-header-flex">
               <div className="account-info--wrapper app-header-flex">
                  <Popover
                     isOpen={isOpen}
                     positions={['left']}
                     containerStyle={{ zIndex: 1111 }}
                     content={
                        <div
                           className="app-popover app-header--popover-account--menu app-popover-hidden-arrow"
                           onMouseLeave={() => setIsOpen(false)}
                           onMouseEnter={() => setIsOpen(true)}
                           style={{ top: 20 }}>
                           <div className="app-popover-content">
                              <div className="app-popover-arrow"></div>
                              <div className="app-popover-inner" role="tooltip">
                                 <div>
                                    <div className="app-popover-inner-content">
                                       <div className="header-account--account-menus">
                                          <div className="header-account--org-info">
                                             <div className="header-account-info app-header-flex org--account-info">
                                                <div className="account-avatar">
                                                   {<AvatarUser name={user.username} />}
                                                </div>
                                                <div className="account-detail">
                                                   <div className="account-detail__wrapper app-header-flex">
                                                      <div className="account-detail__full_name text-ellipsis" title={user.username}>
                                                         {user.username}
                                                      </div>
                                                   </div>
                                                   <div className="account-detail__email text-ellipsis" title={user.username}>
                                                      {user.username}
                                                   </div>
                                                </div>
                                             </div>
                                             <div className="org-info--detail">
                                                <div className="header-account--menu-item app-header-flex">
                                                   <div className="header-account--menu-item--icon app-header-flex">
                                                      <svg width="14" height="14" fill="none" viewBox="0 0 14 14">
                                                         <path fill="#0D1A31" fillRule="evenodd"
                                                            d="M7 2.917v1.166h4.667a1.17 1.17 0 011.166 1.167v5.833a1.17 1.17 0 01-1.166 1.167H2.333a1.17 1.17 0 01-1.166-1.167V2.917A1.17 1.17 0 012.333 1.75h3.5A1.17 1.17 0 017 2.917zm-4.667 8.166H3.5V9.917H2.333v1.166zM3.5 8.75H2.333V7.583H3.5V8.75zM2.333 6.417H3.5V5.25H2.333v1.167zM3.5 4.083H2.333V2.917H3.5v1.166zm1.167 7h1.166V9.917H4.667v1.166zM5.833 8.75H4.667V7.583h1.166V8.75zM4.667 6.417h1.166V5.25H4.667v1.167zm1.166-2.334H4.667V2.917h1.166v1.166zm1.167 7h4.083c.321 0 .584-.262.584-.583V5.833a.585.585 0 00-.584-.583H7v1.167h1.167v1.166H7V8.75h1.167v1.167H7v1.166zm3.5-4.666H9.333v1.166H10.5V6.417zM9.333 8.75H10.5v1.167H9.333V8.75z"
                                                            clipRule="evenodd">
                                                         </path>
                                                      </svg>
                                                   </div>
                                                   <div className="header-account--menu-item--label">{user.username}</div>
                                                </div>
                                             </div>
                                          </div>
                                          <div className="header-account--menu-list">
                                             {/* <a target="_blank" href="/inbox/account/login?prompt=login" className="header-account--menu-item app-header-flex">
                                                <div className="header-account--menu-item--icon app-header-flex">
                                                   <svg width="12" height="12" fill="none" viewBox="0 0 12 12">
                                                      <g stroke="#0D1A31" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" clipPath="url(#clip0)">
                                                         <path
                                                            d="M2.625.375l-2.25 2.25 2.25 2.25M9.375 2.625h-9M9.375 7.125l2.25 2.25-2.25 2.25M2.625 9.375h9">
                                                         </path>
                                                      </g>
                                                      <defs>
                                                         <clipPath id="clip0">
                                                            <path fill="#fff" d="M0 0H12V12H0z"></path>
                                                         </clipPath>
                                                      </defs>
                                                   </svg>
                                                </div>
                                                <div className="header-account--menu-item--label">Đăng nhập tài khoản khác</div>
                                             </a> */}
                                             <a className="header-account--menu-item app-header-flex" onClick={logoutUser}>
                                                <div className="header-account--menu-item--icon app-header-flex">
                                                   <svg width="13" height="14" fill="none" viewBox="0 0 13 14">
                                                      <path fill="#fff" fillOpacity="0.01" d="M0 1H12V13H0z" opacity="0.01"></path>
                                                      <path stroke="#000" strokeLinecap="round" strokeLinejoin="round" d="M3.87 7h7.826M9.087 9.609L11.696 7 9.087 4.391M7.522 1.26H1.26v11.48h6.26"></path>
                                                   </svg>
                                                </div>
                                                <div className="header-account--menu-item--label">Đăng xuất</div>
                                             </a>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     }
                  >
                     <div className="header-account-info app-header-flex org--account-info__top-bar"
                        onMouseLeave={() => setIsOpen(false)}
                        onMouseEnter={() => setIsOpen(true)}
                     >
                        <div className="account-avatar">
                           {<AvatarUser name={user.username} />}
                        </div>
                        <div className="account-detail" style={{ cursor: 'pointer' }}>
                           <div className="account-detail__wrapper app-header-flex">
                              <div className="account-detail__full_name text-ellipsis" title={user.username}>
                                 {user.username}
                              </div>
                              <div className="account-detail__arrow app-header-flex">
                                 <img src={dropdown} />
                              </div>
                           </div>
                           <div className="account-detail__email text-ellipsis" title={user.username}>
                              {user.username}
                           </div>
                        </div>
                     </div>
                  </Popover>
               </div>
               {/* <div className="separater"></div>
               <div className="languages">
                  <div className="app-header--language">
                     <img src={vi} />
                  </div>
               </div> */}
            </div>
         </div>
         {children}
      </div>
   )
}

const mapStateToProps = (state) => {
   const { user } = state;

   return {
      user
   };
};


export default connect(mapStateToProps, {
   logoutUser
})(MainChannel);
